

export default () => {
    $("ul.tabs-author").find("li").on("click", function(e){
        e.preventDefault();
        $("ul.tabs-author").find("li").removeClass("active");
        $(this).addClass("active");
    });
}
